import React from 'react'
import PropTypes from 'prop-types'
import withLayout from '../../../layout/withLayout'
import ContentBox from '../../../layout/component/ContentBox'
import Row from '../../../bootstrap/component/Row'
import Column from '../../../bootstrap/component/Column'
import { lifecycle } from 'recompose'
import { formatDateTime } from '../../../../util/datetime'
import { BACKEND_URL } from '../../../../util/api'
import { renderProcessName } from '../../util/names'

const PROCESS_VERSION_URL = BACKEND_URL + '/process/version/view-version?processVersionId='


const ProcessVersionSummary = ({ name, processVersionList }) => {
    return (
        <ContentBox title={renderProcessName(name)}>
            <Row>
                <Column size={12}>
                    <table className="default-table">
                        <thead>
                            <tr>
                                <th>Activated</th>
                                <th>Deactivated</th>
                                <th>Number of instances</th>
                                <th>View</th>

                            </tr>
                        </thead>
                        <tbody>
                            {processVersionList.map(version => {
                                return (
                                    <tr key={version.id}>
                                        <td>{formatDateTime(version.activated)}</td>
                                        <td>{version.deactivated ? formatDateTime(version.deactivated) : 'active'}</td>
                                        <td>{version.count}</td>
                                        <td><a href={PROCESS_VERSION_URL + version.id} target="_blank" rel="noopener noreferrer">view</a></td>
                                    </tr>)
                            })}
                        </tbody>
                    </table>
                </Column>
            </Row>
        </ContentBox>
    )
}


const VersionSummary = ({ versionSummary, versionSummaryGrouped }) => {
    if (!versionSummaryGrouped || Object.keys(versionSummaryGrouped).length === 0) {
        return null
    }

    const processVersionNameList = Object.keys(versionSummaryGrouped)

    return (
        <div>
            {processVersionNameList.map((name) => {
                return (
                    <ProcessVersionSummary key={name} name={name} processVersionList={versionSummaryGrouped[name]}/>
                )
            })}
        </div>
    )
}


VersionSummary.propTypes = {
    versionSummary: PropTypes.array.isRequired,
    getVersionSummary: PropTypes.func.isRequired,
}

export default lifecycle({
    componentDidMount () {
        this.props.getVersionSummary()
    },
})(withLayout(VersionSummary))




// WEBPACK FOOTER //
// ./src/modules/process/component/version-summary/VersionSummary.js